import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { MenuComponent } from './components/menu/menu.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { UsersComponent } from './pages/users/users.component';
import { PortsComponent } from './pages/ports/ports.component';
import { ParametragesComponent } from './pages/parametrages/parametrages.component';
import { ErreurComponent } from './pages/erreur/erreur.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import {GlobalService} from "./services/global.service";
import {AuthGuard, UserGuard, AdminGuard} from "./services/auth-guard.service";
import {HashLocationStrategy, LocationStrategy} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {RouterModule, Routes} from "@angular/router";
import {HttpClientModule} from "@angular/common/http";
import {LoginComponent} from './pages/login/login.component';
import { CampagnesComponent } from './pages/campagnes/campagnes.component';
import { SuiviComponent } from './pages/suivi/suivi.component';
import { CreditDisponibleComponent } from './pages/credit-disponible/credit-disponible.component';
import { RechargeComponent } from './pages/recharge/recharge.component';
import { StopsComponent } from './pages/stops/stops.component';
import { ArchiveComponent } from './pages/archive/archive.component';
import { LogsComponent } from './pages/logs/logs.component';
import { ServicesComponent } from './pages/services/services.component';
import { WebhooksComponent } from './pages/webhooks/webhooks.component';

import { PaginationComponent } from './components/pagination/pagination.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { StrategiesComponent } from './pages/strategies/strategies.component';
import { SystemConnectionComponent } from './pages/ports/system-connection/system-connection.component';
import { ControleCronComponent } from './pages/controle-cron/controle-cron.component';

import { CampagnesService } from './services/requests/campagnes.service';
import { UsersService } from './services/requests/users.service';
import { StopsService } from './services/requests/stops.service';
import { RechargesService } from './services/requests/recharges.service';
import { PortsService } from './services/requests/ports.service';
import { DevicesService} from './services/requests/devices.service';
import { StrategiesService } from './services/requests/strategies.service';
import { ParametresService } from './services/requests/parametres.service';
import { ControleCronService } from './services/requests/controle-cron.service';
import { ServicesService } from './services/requests/services.service';
import { WebhooksService } from './services/requests/webhooks.service';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { ModifierCampagneComponent } from './pages/modifier-campagne/modifier-campagne.component';
import { SmsComponent } from './pages/sms/sms.component';

const appRoutes: Routes = [
  { path: '', component: LoginComponent, data: { title: 'Connexion' } },
  { path: 'login', component: LoginComponent, data: { title: 'Connexion' } },
  { path: 'unauthorized', component: UnauthorizedComponent, data: { title: 'Accès refusé' } },
  { path: 'ports', component: PortsComponent, canActivate: [UserGuard], data: { title: 'Gestion des machines' } },
  { path: 'parametrage', component: ParametragesComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Paramétrage' } },
  { path: 'users', component: UsersComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Utilisateurs' } },
  { path: 'campagne', component: CampagnesComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Campagnes' } },
  { path: 'stops', component: StopsComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Stops' } },
  { path: 'suivi', component: SuiviComponent, canActivate: [UserGuard], data: { title: 'Suivi des campagnes' } },
  { path: 'archive', component: ArchiveComponent, canActivate: [UserGuard], data: { title: 'Archives' } },
  { path: 'rechargement', component: RechargeComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Rechargement' } },
  { path: 'logs', component: LogsComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Logs' } },
  { path: 'controle-cron', component: ControleCronComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Contrôle des crons' } },
  { path: 'services', component: ServicesComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Services' } },
  { path: 'webhooks', component: WebhooksComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Webhooks réception' } },

  { path: 'dashboard', component: DashboardComponent, canActivate: [UserGuard], data: { title: 'Tableau de bord' } },
  { path: 'strategies', component: StrategiesComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Strategies' } },
  { path: 'system-connection', component: SystemConnectionComponent, canActivate: [UserGuard, AdminGuard], data: { title: 'Connexion système' } },
  { path: '**', component: ErreurComponent, data: { title: 'Page introuvable' } }
];

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    UsersComponent,
    PortsComponent,
    ParametragesComponent,
    ErreurComponent,
    UnauthorizedComponent,
    LoginComponent,
    CampagnesComponent,
    SuiviComponent,
    CreditDisponibleComponent,
    RechargeComponent,
    StopsComponent,
    ArchiveComponent,
    LogsComponent,
    ServicesComponent,
    WebhooksComponent,

    PaginationComponent,
    DashboardComponent,
    StrategiesComponent,
    SystemConnectionComponent,
    ControleCronComponent,
    ConfirmationModalComponent,
    ModifierCampagneComponent,
    SmsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, { useHash: false }),
    FontAwesomeModule,
    FormsModule
  ],
  providers: [
    GlobalService,
    AuthGuard,
    UserGuard,
    AdminGuard,
    CampagnesService,
    UsersService,
    StopsService,
    RechargesService,
    PortsService,
    DevicesService,
    StrategiesService,
    ParametresService,
    ControleCronService,
    ServicesService,
    WebhooksService,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
